module.exports = __webpack_public_path__ + "img/wok-shop_thumbnail.680da5ba.jpg";